<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import Header from './view/Header';
export default {
  // components: {
  //   Header
  // }
  created() {
    // localStorage.setItem(
    //     "userInfo",
    //     JSON.stringify({ access_token: "liu" })
    //   );
  }
};
</script>

<style>
#app {
  width: 100%;
  height: 100vh;
  max-width: 600px;
  min-width: 300px;
  margin: 0 auto;
  /* border: 1px solid #000000; */
  background: linear-gradient(180deg, #cee8ff 0%, #f2fffd 100%);
  opacity: 0.95;
}
</style>
